/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { MutateIntegrationDrawer } from "./MutateIntegrationDrawer";

export const MutateIntegrationSelector = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary onClick={() => setModalOpen(true)} type="button">
        Create integration
      </ButtonPrimary>
      <MutateIntegrationDrawer
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};
